import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 .833C4.94.833.833 4.94.833 10S4.94 19.167 10 19.167 19.167 15.06 19.167 10 15.06.833 10 .833Zm3.667 10.084h-2.75v2.75a.92.92 0 0 1-.917.916.92.92 0 0 1-.917-.916v-2.75h-2.75A.92.92 0 0 1 5.417 10a.92.92 0 0 1 .916-.917h2.75v-2.75A.92.92 0 0 1 10 5.417a.92.92 0 0 1 .917.916v2.75h2.75a.92.92 0 0 1 .916.917.92.92 0 0 1-.916.917Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };